const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#B12A1C',
                hover: '#961E11'
            }
        }
    };
};
const themeDependent = (theme) => {
    const themeDependent = {
        components: {
            MuiPaginationItem: {
                styleOverrides: {
                    root: {
                        '&.MuiPaginationItem-previousNext': {
                            color: '#000',
                            backgroundColor: '#FFCC01'
                        },
                        '&.MuiPaginationItem-previousNext:hover, &.MuiPaginationItem-previousNext:focus': {
                            backgroundColor: '#EBC11C'
                        }
                    }
                }
            }
        }  
    }
    return themeDependent;
};

export default {
    baseTheme,
    themeDependent
};
